/**
 * The single source of truth for `<html lang>` and `<html dir>` — §12.3.
 *
 * Direction is set in exactly one place. Components never read or set it
 * themselves; they use logical Tailwind properties (`ms-*`, `me-*`, `start-*`,
 * `end-*`) and get the right layout in both directions for free. The
 * `next-scene/no-physical-properties` lint rule enforces that.
 */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { directionFor } from './config'

export function DirectionProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation()
  const language = i18n.resolvedLanguage ?? i18n.language

  useEffect(() => {
    const root = document.documentElement
    root.lang = language
    root.dir = directionFor(language)
  }, [language])

  return children
}
